<div class='separator-horizontal'/>

<style>
  .separator-horizontal {
    flex-shrink: 0;

    width: 100%;
    height: 2px;

    margin: -1px 0px;

    background: var(--grey-3);
  }

  :global(body.dark) .separator-horizontal {
    background: var(--grey-7);
  }
</style>
